module.exports = __webpack_public_path__ + "img/signFail.7fc632d9.png";